import * as apiGet from 'api/erp/GetErpGetStatusV1';
import { Optional } from 'functions/promiseExtensions';
import * as ErpSource from 'types/_general/Store/ErpSource';
import { upperCaseFirstLetter } from 'types/_general/String';

export * as ErpSourceList from 'types/_general/Store/ErpSourceList';

export type Type = ErpSource.Type[];

export function create(): Type {
	return [];
}

export async function getFromApi(): Promise<Type> {
	const response = await apiGet.callApi();
	return response.map(mapFromApi).getOrDefault([]);
}

export function mapFromApi(input: apiGet.ResponseData): Type {
	const output: Type = [];
	for (const [key, value] of Object.entries(input)) {
		if (value.status === 'healthy')
			output.push({
				id: key,
				name: upperCaseFirstLetter(key),
			});
	}
	return output;
}

export function getNameById(obj: Type, id: string): string {
	return Optional.Maybe(obj.find((e) => e.id === id))
		.map((e) => e.name)
		.getOrDefault('–');
}
